<!-- Copyright (c) 2024 Digital Systems (M) Sdn. Bhd. -->

<template>
  <div class="checkbox-main">
    <label>
      {{ title }}
      <input type="checkbox" v-model="pIsChecked" :disabled="isDisabled" @change="checkBoxChanged" ref="checkBoxInput">
    </label>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  components: {
  },
  computed: {
  },
  data: function() {
    return {
      pIsChecked: false,
    };
  },
  props: {
    // Public properties
    title: { type: String, default: 'Check Box' }, // Set the title of the checkbox that will be displayed on the right of the check box
    isChecked: { type: Boolean, default: false }, // The state of the checkbox whether it is checked (true) or unchecked (false), use .sync for 2 way binding
    isDisabled: { type: Boolean, default: false }, // Set to true if the check box is disabled

    // Public events
    // @checkBoxClicked - fired when the check box is clicked or toggled with the keyboard, returns a boolean indicating checkbox state
  },
  methods: {
    checkBoxChanged: function(event) { // event listener registered on change instead of on click
      this.$emit("update:isChecked", this.pIsChecked); // because the click event fires twice, once for the label and once for the input; listening on change is cleaner than on click
      this.$emit("checkBoxClicked", this.pIsChecked); // but still keep the "checkBoxClicked" event name instead of changing it, to support backwards compatability with CheckBox v1
    }, // also update the prop first before emitting checkBoxClicked, so that the prop value will have already changed when checkBoxClicked is listened on, this is similar to how CheckBox v1 works

    // Public Methods
    setFocus: function() {
      this.$refs.checkBoxInput.focus();
    },
  },
  mounted() {
    this.pIsChecked = this.isChecked;
  },
  watch: {
    isChecked: {
      handler: function(val) {
        this.pIsChecked = val;
      },
      deep: true,
    },
  }
}
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';

.checkbox-main > label {
  margin: 0;
  cursor: pointer;
  user-select: none;

  > input { // actual checkbox
    opacity: 0; // hide actual checkbox
    cursor: pointer;
  }

  > input:disabled { // actual checkbox when input is disabled
    cursor: default;
  }

  &::before { // add pseudo checkbox
    border: 1px solid black;
    border-radius: 3px;
    height: 12px;
    width: 12px;
    content: '\00A0'; // no-break space, used to force text-align and line-height to take effect
    text-align: center; // so that the pseudo checkbox and the label are vertically aligned
    line-height: 11px;
    display: inline-block;
    cursor: pointer;
  }

  &:has(> input:checked)::before { // pseudo checkbox when input is checked
    background-color: rgb(64, 64, 64);
    color: white;
    content: '✔';
    font-size: 10px;
  }

  &:has(> input:focus)::before { // pseudo checkbox when input is in focus
    box-shadow: 0 0 0 3px rgb(168, 199, 250);
  }

  &:has(> input:disabled)::before { // pseudo checkbox when input is disabled
    border: 1px solid rgb(200, 200, 200);
    cursor: default;
  }

  &:has(> input:disabled) { // label when input is disabled
    opacity: 0.5;
    cursor: default;
  }
}
</style>